import { withReportsFromDay } from '@/common/time'
const sessionKey = 'report_userranking_wizard'

export interface WizardData {
  from: Date
  to: Date
}

export const cleanWizardData = (): WizardData => {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 0, 0);

  const empty: WizardData = {
    from: startOfToday,
    to: endOfToday,
  };
  
  return withReportsFromDay(empty)
}
